import { format, parseISO } from 'date-fns';

import { CRYPTO_ADDRESS_CHANGED_NOTICE_DAYS } from './constants';

const DAY_MS = 86_400_000;

/** EDGE-32497 (design §5): true iff `addressChangedAt` parses to a finite instant that is not in
 *  the future and is younger than CRYPTO_ADDRESS_CHANGED_NOTICE_DAYS. NaN-safe: null, undefined,
 *  '' or an unparseable string is `false` — never a thrown RangeError from date-fns. */
export const shouldShowAddressChangedNotice = (
  addressChangedAt: string | null | undefined,
  nowMs: number
): boolean => {
  if (!addressChangedAt) return false;
  const t = Date.parse(addressChangedAt);
  if (!Number.isFinite(t)) return false;
  const age = nowMs - t;
  return age >= 0 && age < CRYPTO_ADDRESS_CHANGED_NOTICE_DAYS * DAY_MS;
};

/** The local date-fns convention: CryptoArrivalsList.tsx:2,109 uses
 *  `format(parseISO(item.postedAt), 'MMM d, h:mm a')`. Absent or unparseable → '' (panel E5):
 *  the sheet gates the call with shouldShowAddressChangedNotice, and this makes the formatter
 *  safe even when a caller forgets to. */
export const formatAddressChangedDate = (addressChangedAt: string | null | undefined): string => {
  if (!addressChangedAt || !Number.isFinite(Date.parse(addressChangedAt))) return '';
  return format(parseISO(addressChangedAt), 'MMM d, yyyy');
};
